import http from "../../http"
import { showSuccess } from "../../utils/snackbar"

export const httpApiCall = async (payload) => {
    const { method, endpoint, key, params, headers } = payload
    const response = await http(method, endpoint, {
        apiData: params,
        headers: {
            ...headers,
            "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
            Pragma: "no-cache",
            Expires: "0",
        },
    })
    return response.data
}

export const login = async (apiBody) => {
    const { payload } = apiBody
    const response = await http("POST", "api/v1/authenticate-user", {
        apiData: payload,
    })

    response.data?.fleet_manager_data?.forEach((app) => {
        // Check if mobile_asset_slugs exists and is an array
        if (Array.isArray(app.mobile_asset_slugs) && app.mobile_asset_slugs.length > 0) {
            const key = `${app.app_key}_mobile_asset_slugs`
            // Store in localStorage as a JSON string
            localStorage.setItem(key, JSON.stringify(app.mobile_asset_slugs))
        }
    })
    return response.data
}

export const verifyOtpApi = async (apiBody) => {
    const { payload } = apiBody
    const response = await http("POST", "api/v1/verify-email-otp", {
        apiData: payload,
    })

    return response
}

export const resendOtpApi = async (apiBody) => {
    const { payload } = apiBody
    const response = await http("POST", "api/v1/resend-email", {
        apiData: payload,
    })

    showSuccess(response?.message)
    return response
}

export const fetchWrapperByFilterApiCall = async (apiBody) => {
    const { payload } = apiBody
    const response = await http("POST", "api/v1/data", {
        apiData: payload,
    })

    return response.data
}

export const saveRouteApiCall = async (apiBody) => {
    const { payload } = apiBody
    const response = await http("POST", "api/v1/routing/add", {
        apiData: payload,
    })

    showSuccess("Route Saved Successfully")

    return response.data
}
